import { ModalSize } from '../core/components/Modal/types';

export type LegacyModalSize = 'small' | 'medium' | 'large' | 'xlarge';

enum sizePairs {
  small = 'sm',
  medium = 'md',
  large = 'lg',
  xlarge = 'xl',
}

function isLegacyModalSize(inputSize: LegacyModalSize | ModalSize): inputSize is LegacyModalSize {
  return inputSize in sizePairs;
}

export const convertLegacyModalSize = (inputSize: LegacyModalSize | ModalSize): ModalSize => {
  return isLegacyModalSize(inputSize) ? sizePairs[inputSize] : inputSize;
};
